import React, { useContext } from 'react';
import classnames from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import { MobileContext } from '../../../Context';
import s from './StatIcon.scss';
export var StatIcon = function (_a) {
    var Icon = _a.icon, isActive = _a.isActive, isDisabled = _a.isDisabled;
    var isMobile = useContext(MobileContext);
    return (React.createElement(Icon, { size: IconSize.MEDIUM, className: classnames(s['icon'], isDisabled && s['disabled'], isActive && s['active'], !isMobile && !isDisabled && s['with-hover']) }));
};
StatIcon.displayName = 'StatIcon';
export default StatIcon;
//# sourceMappingURL=StatIcon.js.map